import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import { DissertationsEdit, DissertationsPage } from '../pages/CMSPages/index';
import React from 'react';

const FacultyRoutes = () => (
  <>
    <Route
      path={routes.cmsDissertation}
      element={
        <CMSWrapper permissions={['dissertations.index']}>
          <DissertationsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsDissertationCreate}
      element={
        <CMSWrapper permissions={['dissertations.store']}>
          <DissertationsEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsDissertationEdit}/:id`}
      element={
        <CMSWrapper permissions={['dissertations.show']}>
          <DissertationsEdit mode={'edit'} />{' '}
        </CMSWrapper>
      }
    />
  </>
);

export default FacultyRoutes;
